<template>
  <div class>
    <!--=== Header Start ===-->
    <div
      class="
        page-effect
        RegEvent-wrapper
        edu-rage
        event_list_reg
        ss-pre-ev-list
      "
    >
      <section class="event-box-list-wrapper">
        <div class="container-fluid">
          <p>helooooo</p>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import jQuery from "jquery";
let $ = jQuery;
//var self;
import Vue from "vue";
import VueMoment from "vue-moment";
import moment from "moment-timezone";
//import axios from "axios";
//import { bus } from "@/main";
Vue.use(VueMoment, {
  moment,
});


export default {
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {
    // self = this;
  },
  mounted() {
    if (this.$route.query.error_description) {
      console.log("linked in error");
    } else {
      console.log("access token=====", this.$route.query.code);

      $.ajax({
        url: "https://www.linkedin.com/oauth/v2/accessToken?grant_type=authorization_code&code=AQSey6eo_H_R2GUgyTsUgCr-uKeJi1SEyOzM4q_ecnhFIc9iiHdr6he3UOYlNbwxCoPGSsgwShieYaNdjPV45_LX4lgAHIRbQ3PCDv72yW-FviXi1XCAvRoPM2EYbfnqLMMA2yxWgnn3AHM1b7mHeNrC7T2nhfbCF3ysLpbv1cvdE9QHJHXqodhBM-gUAxZ-dFBUtXu0hTuTuNAqMts&redirect_uri=https://uatonair.e2m.live/provider/linkedIn&client_id=78ncaql532tryi&client_secret=3VPsRrRPzClJifbG",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        type: "POST" /* or type:"GET" or type:"PUT" */,
        dataType: "json",
        data: {},
        success: function (result) {
          console.log("linkedin------", JSON.stringify(result));
        },
        error: function () {
          console.log("error");
        },
      });


      // var config = {
      //   method: "post",
      //   url: "https://www.linkedin.com/oauth/v2/accessToken?grant_type=authorization_code&code=AQSey6eo_H_R2GUgyTsUgCr-uKeJi1SEyOzM4q_ecnhFIc9iiHdr6he3UOYlNbwxCoPGSsgwShieYaNdjPV45_LX4lgAHIRbQ3PCDv72yW-FviXi1XCAvRoPM2EYbfnqLMMA2yxWgnn3AHM1b7mHeNrC7T2nhfbCF3ysLpbv1cvdE9QHJHXqodhBM-gUAxZ-dFBUtXu0hTuTuNAqMts&redirect_uri=https://uatonair.e2m.live/provider/linkedIn&client_id=78ncaql532tryi&client_secret=3VPsRrRPzClJifbG",
      //   headers: {
      //     "Content-Type": "application/x-www-form-urlencoded",
      //   },
      // };

      // axios(config)
      //   .then(function (response) {
      //     console.log("linkedin------", JSON.stringify(response.data));
      //   })
      //   .catch(function (error) {
      //     console.log(error);
      //   });
    }
  },
  methods: {
    getQueryString(data = {}) {
      return Object.entries(data)
        .map(
          ([key, value]) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        )
        .join("&");
    },
  },
};
</script>